// pointDropdown.ts
import { Dropdown } from "./dropdown";
import { detectorControls, Mode, state } from "../../app";
import { apiDeleteSector, apiFetchSectorsForFolder } from "scripts/api/sector";
import { Detector } from "scripts/classes/detector";
import { map } from "scripts/map/map";

export class DetectorDropdown extends Dropdown<Detector> {
    private newSectorBtn: HTMLButtonElement | null = null;

    protected async onOpen() {}

    protected onClose() {}

    /**
     * Очистка меню
     * Используеттся при удалении папки
     */
    public clearMenu() {
        this.btn.innerHTML = '<span id="pointDropdownLabel">Датчик</span><svg class="dropdown-chevron" viewBox="0 0 24 24" fill="currentColor" width="14" height="14"><path d="M7 10l5 5 5-5z" /></svg>';
        this.menu.innerHTML = '<div class="ui-dropdown-loading">Загрузка…</div>';
    }

    public async loadMenu() {
        if (!state.folder) return;

        state.detectors.forEach(d => {d.removeGraphics()});

        state.detectors = [];
        this.menu.innerHTML = '<div class="ui-dropdown-loading">Загрузка…</div>';
        
        const sectors = await apiFetchSectorsForFolder(state.folder.id);
        console.log('Полученные сектора:', sectors);
        this.menu.innerHTML = '';
        this.setAddNewDetectorElement(); // Новый датчик

        //Добавляем детекторы в выпадающий список
        sectors?.forEach(sectorData => {
            console.log('Создаю детектор для:', sectorData.name, sectorData);
            // Создаем детектор со всеми данными из API
            const detector = new Detector(
                sectorData.id, 
                sectorData.lat, 
                sectorData.lng, 
                sectorData.distance, 
                sectorData.coneWidth, 
                false,
                sectorData // Передаем все данные сектора в конструктор
            );

            console.log('Созданный детектор:', detector);
            
            // Убеждаемся, что все поля заполнены
            detector.azimuth = sectorData.azimuth;
            detector.name = sectorData.name;
            detector.startAngle = sectorData.startAngle;
            detector.endAngle = sectorData.endAngle;
            detector.stepRay = sectorData.stepRay;
            detector.criticalValue = sectorData.criticalValue;

            detector.drawSector();
            detector.drawMarker();

            state.detectors.push(detector);

            const savedVisibility = localStorage.getItem(`detector_visible_${detector.id}`);
            if (savedVisibility !== null) {
                const isVisible = savedVisibility === 'true';
                detector.setVisible(isVisible);
            } else {
                detector.setVisible(true);
            }

            this.createDetectorLine(detector);
        });
        
    }

    /**
     * Установка детектора в заголовок спписка
     * @param id 
     */
    public setSelect(id: string){
        const item = document.querySelector(`.ui-dropdown-sector-${id}`) as HTMLElement;
        const detector = state.detectors.find(d => d.id == id);
        if (!detector) return;

        this.onSelect(detector, item);
    }

    private onSelect(detector: Detector, itemEl: HTMLElement) {

        if(!detector.lat || !detector.lng){ throw new Error("Ошибка! У датчика отсутствуют координаты")}
        if(!detector.azimuth){ throw new Error("Ошибка! У датчика отсутствует азимут")}

        // TODO: Возвращение изначального сектора на свое место
        if (state.resetDetector) {
            state.detector?.removeGraphics();

            state.resetDetector.drawMarker();
            state.resetDetector.drawSector();

            state.resetDetector = null;
        }
        
        this.menu.querySelectorAll('.ui-dropdown-item').forEach(i => i.classList.remove('active'));
        itemEl.classList.add('active');
        this.label.textContent = detector.name ?? "Unknown";
        this.changeActiveMarker(detector);
        
        this.changeActiveSector(detector);

        detectorControls.cone.setCone(detector.coneWidth ?? 30);
        detectorControls.coords.setCoords(detector.lat, detector.lng);        
        detectorControls.coords.setAzimuth(detector.azimuth);
        detectorControls.start.setEnable();
        detectorControls.reset.setEnable();

        state.detector = detector;
        state.mode = Mode.justWatching;

        map.flyTo({ center: [detector.lng, detector.lat], zoom: 15 });
    }

    public setNewSector() {
        // Если предыдущий датчик был временным (не сохранён, id "temp") —
        // убираем его точку и сектор с карты. Иначе при повторном нажатии
        // «Новый датчик» они «зависают»: temp нигде в state.detectors не хранится,
        // поэтому loadMenu его не почистит.
        if (state.detector?.id === 'temp') {
            state.detector.removeGraphics();
        } else {
            state.detector?.marker?.deactivate();
        }
        state.detector = null;

        this.menu.querySelectorAll('.ui-dropdown-item').forEach(i => i.classList.remove('active'));
        state.mode = Mode.waitForPoint;
        
        this.newSectorBtn?.classList.add('active');
        this.label.textContent = 'Установите датчик';

        detectorControls.coords.setCoords(null, null);
        detectorControls.coords.setAzimuth(null);
        detectorControls.start.setDisable();
        detectorControls.reset.setDisable();
        detectorControls.save.setDisable();

        this.close();
    }

    private setAddNewDetectorElement() {
        const addItem = document.createElement('button');
        addItem.className = 'ui-dropdown-item';
        addItem.innerHTML = 'Новый датчик';
        addItem.addEventListener('click', (e) => {
            e.stopPropagation();
            this.setNewSector();
        });
        this.menu.appendChild(addItem);
        this.newSectorBtn = addItem;
    }

    private createDeleteBtn(detectorId: string) {
        const deleteBtn = document.createElement('button');
        deleteBtn.className = 'ui-dropdown-item';
        deleteBtn.style.width = '20%';
        deleteBtn.style.padding = '0';
        deleteBtn.style.justifyContent = 'center';
        deleteBtn.innerHTML = '❌';
        deleteBtn.addEventListener('click', async () => {
            await this.deleteDetector(detectorId);
        });
        return deleteBtn;
    }


    private createDetectorLine(detector: Detector){
        const div = document.createElement('div');
        div.classList.add('row');
        div.style.alignItems = 'center';
        div.style.width = '100%';

        const visibilityCheckbox = document.createElement('input');
    visibilityCheckbox.type = 'checkbox';
    visibilityCheckbox.className = 'detector-visibility-checkbox';
    visibilityCheckbox.checked = detector.isVisible !== undefined ? detector.isVisible : true;
    visibilityCheckbox.style.margin = '0 8px 0 12px';
    visibilityCheckbox.style.width = '16px';
    visibilityCheckbox.style.height = '16px';
    visibilityCheckbox.style.cursor = 'pointer';
    visibilityCheckbox.style.accentColor = '#3b82f6';
    
    visibilityCheckbox.addEventListener('change', (e) => {
        e.stopPropagation();
        const isVisible = visibilityCheckbox.checked;
        detector.setVisible(isVisible);
        localStorage.setItem(`detector_visible_${detector.id}`, String(isVisible));
    });

        const item = document.createElement('button');
        item.className = `ui-dropdown-item ui-dropdown-sector-${detector.id}`;
        item.style.flex = '1';
        item.style.textAlign = 'left';
        item.innerHTML = detector.name ?? "No name";
        item.addEventListener('click', (e) => {
        e.stopPropagation();
        this.onSelect(detector, item);
        this.close();
    });

            
        const deleteBtn = this.createDeleteBtn(detector.id);
        div.appendChild(visibilityCheckbox);
        div.appendChild(item);
        div.appendChild(deleteBtn);
        this.menu.appendChild(div);
    }


    private changeActiveMarker(detector: Detector) {
                // Деактивируем все маркеры
        state.detectors.forEach(d => {
            d.marker?.deactivate();
        });
        
        // Активируем маркер
        detector.marker?.activate();
    }

    private changeActiveSector(detector: Detector) {
        // Сбрасываем цвет всех секторов на красный
        state.detectors.forEach(d => {
            d.sector?.setSectorDefault();
        });
        
        // Выделяем выбранный жёлтым
        detector.sector?.setSectorSelected();
    }

    /**
     * Удаление детектора 
     * @param detectorId Id детектора
     */
    private deleteDetector = async (detectorId: string) => {
        const selectedId = state.detector?.id ?? null;

        // Отправляем запрос на сервер, для удаления
        await apiDeleteSector(detectorId);
        // Перезагружаем меню (пересоздаёт все объекты Detector заново)
        await this.loadMenu();

        if (selectedId === null || selectedId === detectorId) {
            // Удалён выбранный датчик (или выбора не было) — сбрасываем выбор и
            // контролы, иначе поля координат/азимута и кнопки «Запустить расчёт»/
            // «Сохранить» остаются привязаны к удалённому датчику.
            this.clearSelection();
        } else {
            // Удалён другой датчик: loadMenu пересоздал объекты, поэтому заново
            // привязываем выбор к свежему объекту того же датчика, иначе контролы
            // будут править «мёртвую» ссылку.
            const fresh = state.detectors.find(d => d.id === selectedId);
            if (fresh) {
                state.detector = fresh;
                document.querySelector(`.ui-dropdown-sector-${selectedId}`)?.classList.add('active');
            } else {
                this.clearSelection();
            }
        }
    }

    /**
     * Сбрасывает выбранный датчик и приводит контролы в пустое/выключенное
     * состояние (как после смены папки / создания нового сектора).
     */
    private clearSelection() {
        state.detector = null;
        state.resetDetector = null;
        state.mode = Mode.justWatching;

        this.label.textContent = 'Датчик';
        this.menu.querySelectorAll('.ui-dropdown-item').forEach(i => i.classList.remove('active'));

        detectorControls.coords.setCoords(null, null);
        detectorControls.coords.setAzimuth(null);
        detectorControls.start.setDisable();
        detectorControls.reset.setDisable();
        detectorControls.save.setDisable();
    }
}